import { useRouter } from "next/router"
import Link from "next/link"
import cn from "classnames"
import Image from "components/Image"
import Pagination from "components/Pagination"
import { formatNewsDate, NEWS_ARTICLES_PER_PAGE } from "utilities/newsHelpers"
import { getStoryblokLink } from "utilities/getStoryblokLink"

const ArticleItem = ({ featured_image, date, title, slug, article_type }) => {
  return (
    <article className="rounded-10 bg-white shadow lg:flex">
      <div className="relative isolate lg:basis-1/2 xl:basis-2/5">
        <div className="absolute z-10 bg-orange px-3 py-2 font-secondary font-medium leading-4 text-white">
          {article_type.component === "external_news_article" ? "News Article" : "Press Release"}
        </div>
        <Image
          src={featured_image?.filename !== "" ? featured_image?.filename : "/assets/news-placeholder.webp"}
          alt={featured_image?.alt ?? "Placeholder image"}
          placeholder={featured_image?.blurDataURL ? "blur" : "empty"}
          blurDataURL={featured_image?.blurDataURL}
          width={250}
          height={232}
          className={cn("relative inset-0 h-full w-full lg:absolute", {
            "object-contain": featured_image?.filename.endsWith(".png") || !featured_image?.filename !== "",
            "object-cover": !featured_image?.filename.endsWith(".png") && featured_image?.filename !== "",
          })}
        />
      </div>
      <div className="flex flex-col gap-3 px-10 py-8 lg:basis-1/2 xl:basis-3/5">
        {date && date !== "" ? (
          <time dateTime={date} className="font-tertiary uppercase">{`${formatNewsDate(date)}`}</time>
        ) : null}
        <h1 className="font-secondary text-l2">{title}</h1>
        <Link
          href={
            article_type.component === "external_news_article" ? getStoryblokLink(article_type.link) : `/news${slug}`
          }
          target={article_type.component === "external_news_article" ? "_blank" : "_self"}
          className="text-m1 font-bold text-teal-dark underline hover:no-underline"
        >
          Read {article_type.component === "external_news_article" ? `at ${article_type.link_label}` : "full article"}
        </Link>
      </div>
    </article>
  )
}

export default function NewsArticlesSection({ newsArticles, total, number }) {
  const router = useRouter()
  return (
    <section className="bg-springWood px-6 py-12">
      <div id="news-section" className="mx-auto max-w-screen-xl">
        <div className="grid w-full gap-10 sm:grid-cols-2">
          {newsArticles?.map((article, idx) => (
            <ArticleItem {...article} key={idx} />
          ))}
        </div>
        <Pagination
          scrollAnchor="news-section"
          pageCount={Math.ceil(total / NEWS_ARTICLES_PER_PAGE)}
          currentPage={number}
          setCurrentPage={(number) =>
            router.push(`${router.pathname.replace("[number]", number)}`, null, {
              scroll: false,
            })
          }
        />
      </div>
    </section>
  )
}
